import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';

export default function DateTimeInput({ value, onChange, min, ...props }) {
    return (
        <StyledInput
            {...props}
            type="datetime-local"
            value={value}
            onChange={onChange}
            min={min}
        />
    );
}

const StyledInput = styled.input`
    border: 1.5px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 14px 16px;
    font-size: 16px;
    outline: none;
    color: ${colors.nightDark};
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.15s;
    font-family: inherit;
    &:focus {
        border-color: ${colors.occasionalPurple};
    }
`;
